
import React from 'react';
import { motion } from 'framer-motion';
import { Target, Zap, TrendingUp } from 'lucide-react';

const IdealCustomer = () => {
  const profiles = [
    {
      icon: Target,
      title: 'Security-Conscious Organisations',
      points: [
        'Value proactive security measures',
        'Committed to team development',
        'Seeking industry certifications'
      ]
    },
    {
      icon: Zap,
      title: 'Fast-Growing Companies',
      points: [
        'Scaling their security infrastructure',
        'Building security-first culture',
        'Need expert guidance quickly'
      ]
    },
    {
      icon: TrendingUp,
      title: 'Compliance-Driven Enterprises',
      points: [
        'Meeting regulatory requirements',
        'Ensuring ongoing compliance',
        'Regular security assessments needed'
      ]
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-[#422680] via-[#660F56] to-[#F54952] bg-clip-text text-transparent">
              Ideal For
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Organisations committed to building a strong security foundation
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {profiles.map((profile, index) => {
            const Icon = profile.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-8 rounded-2xl border-2 border-gray-100 hover:border-[#422680] hover:shadow-xl transition-all"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#422680] to-[#F54952] rounded-xl flex items-center justify-center mb-6">
                  <Icon className="text-white" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-6">{profile.title}</h3>
                <ul className="space-y-3">
                  {profile.points.map((point, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <div className="w-2 h-2 bg-[#F54952] rounded-full mt-2 shrink-0"></div>
                      <span className="text-gray-600">{point}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default IdealCustomer;
